// import React from 'react'
import React, { useEffect, useMemo, useRef, useState } from "react";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { CustomImageModal, customSortByKey, downloadAsExcel, handleErrorToast, downloadAsExcelforRating } from "../CustomFunctions";
import { toast, ToastContainer } from "react-toastify";
import { Active, CircularGrid, DownloadIcon, Employee, Eye, Filter, Office, SearchSmall, Calender, BlueEye, UpdatePencil } from "../AllSvg";
import { formatDateTime, formattedDateLong, formattedDate } from "../Date";
import { UploadAppraisalDetailsByHODAdmin, UploadAppraisalDetailsByHOD, ViewAppraisalDetailsHODAdmin, ViewAppraisalDetailsByHOD, ViewAppraisalDetailsByRHHOD, UploadAppraisalDetailsByRHHOD, ViewAppraisalDetailsRHHODAdmin, UploadAppraisalDetailsByRH, ViewAppraisalDetailsByRH, UploadAppraisalDetailsByRHHODAdmin, AppraisalParameterHeadingAdd, AppraisalParameterHeadingUpdate, UpdateAppraisalType, DeleteAppraisalType, AddAppraisalType, AppraisalParameterHeadingDelete, AddAppraisalQuickForm, AddAppraisalQuickSetup, UpdateAppraisalQuickSetup, DeleteAppraisalQuickSetup, ViewAppraisalDetailsbyQuickSetup, AddRangeType, UpdateRangeType, DeleteRangeType, AppraisalApproverRatingModal } from "./AppraisalComponents";
import usePermission from "../../config/permissions";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { CSSForFilterDropdown } from "../CustomUtilities";


const AppraisalQuickFormSetup = () => {

  const [buffer, setBuffering] = useState(false);
  const [appraisalQuickFormSetup, setAppraisalQuickFormSetup] = useState([]);
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();


  const getAppraisalQuickSetupData = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${toggleCompany}/`);
      setAppraisalQuickFormSetup(res.data);
    } catch (error) {
      handleErrorToast(error)
    } finally {
      setBuffering(false);
    }
  }

  useEffect(() => {
    getAppraisalQuickSetupData();
  }, [toggleCompany]);

  return (
    <div>
      <div className="table-css-white-background">
        <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
          <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
            <div className="repo-heading font-weight500 font-size-heading">
              Quick Appraisal Setup
            </div>
            <div className="field-cont">
              {SUPER_ADMIN && <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
                <Office />
                <select
                  value={toggleCompany}
                  onChange={(e) => setToggleCompany(e.target.value)}
                  className="dropdown font-size-subheading  "
                  style={{ cursor: "pointer" }}
                >
                  <option value="null">Select SubCompany</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                </select>
              </div>}
              <AddAppraisalQuickSetup getAppraisalQuickSetupData={getAppraisalQuickSetupData} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
            </div>
          </div>
          {/* <div className='table-box  scroll-container-table' style={{ width: "100%" }}> */}
          <table className="table-css" >
            <thead className="table-heading">
              <tr className="custom-table-head-tr">
                <th className="table-heading-text text-left-sr">S. No.</th>
                <th className="table-heading-text text-center">Rating Period</th>
                <th className="table-heading-text text-center">Status</th>
                <th className="table-heading-text text-center">Forms Count</th>
                <th className="table-heading-text text-center">View Forms</th>
                {toggleCompany === 'null' && <th className="table-heading-text text-center">Sub Company</th>}
                <th className="table-heading-text text-center">Created At</th>
                <th className="table-heading-text text-center">Last Update</th>
                <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner-bgdatil"></div>//buffering logic
            ) : (
              <tbody>
                {appraisalQuickFormSetup
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .sort((a, b) =>
                    a.sub_company_title?.localeCompare(b.sub_company_title, "en", {
                      ignorePunctuation: true,
                    })
                  )
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="custom-table-head-td ">
                        <td className="table-body">{index + 1}</td>
                        <td className="table-body text-center ">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}</td>
                        <td className="table-body text-center align-center">
                          {
                            i.is_active === true || i.is_active === 'True' ?
                              <button className="priority-button color-tab-green">
                                Active
                              </button>
                              :
                              <button className="priority-button color-tab-red">
                                Inactive
                              </button>
                          }
                        </td>
                        <td className="table-body text-center ">{i.emp_form_count}</td>
                        <td className="table-body text-center" >
                          <ViewAppraisalDetailsbyQuickSetup i={i} />
                        </td>
                        {toggleCompany === 'null' && <td className="table-body text-center">{i.sub_company_title}</td>}
                        <td className="table-body align-center">
                          {formatDateTime(i?.created_at).longdate}
                          <br />
                          <small>{formatDateTime(i?.created_at).time}</small>
                        </td>

                        <td className="table-body align-center">
                          <>
                            {i.updated_by &&
                              <>
                                <CustomImageModal customStyle>
                                  {i.updated_by_profilepic ? (
                                    <img
                                      src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                      alt="profile" className="profile-img"
                                    />
                                  ) : (
                                    <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                  )}
                                </CustomImageModal>
                                <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                                {/* At- */}
                              </>
                            }
                            {i.updated_by ?
                              <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                              :
                              <>
                                {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                <br />
                                <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                              </>}
                          </>
                        </td>
                        <td className="table-body text-right" style={{ justifyContent: 'right' }}>

                          <div className='flex-row justify-end'>
                            <UpdateAppraisalQuickSetup
                              i={i}
                              getAppraisalQuickSetupData={getAppraisalQuickSetupData}
                              SUB_COMPANIES={SUB_COMPANIES}
                              SUPER_ADMIN={SUPER_ADMIN}
                            />
                            {i.emp_form_count == 0 && <DeleteAppraisalQuickSetup
                              i={i}
                              getAppraisalQuickSetupData={getAppraisalQuickSetupData}
                            />}

                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
          {/* </div> */}
        </div>
      </div>
    </div>
  )
}

// --------------------------------main component for pending approvals list for reporting head, hod, admin

// const AppraisalPendingApprovalsList = ({ level }) => {
//   const [loading, setLoading] = useState(false);
//   const [rows, setRows] = useState([]);
//   const [activeEmp, setActiveEmp] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedRH, setSelectedRH] = useState(`${sessionStorage.getItem("emp_code")}`);
//   const [selectedSubCompany, setSelectedSubCompany] = useState(`${sessionStorage.getItem("company_id")}`);

//   const [buffer1, setBuffering1] = useState(true);
//   const [ratingPeriod, setRatingPeriod] = useState("null");
//   const [ratingPeriodList, setRatingPeriodList] = useState([]);
//   const [employeeGet, setEmployeeGet] = useState("null");

//   useEffect(() => { fetchPending(); }, [level, selectedRH]);

//   const getApprasalList = async () => {
//     setBuffering1(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
//       const activeSetup = res.data.find(r => r.is_active);
//       if (activeSetup) setRatingPeriod(activeSetup.id);
//       setRatingPeriodList(res.data);
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering1(false);
//     }
//   };

//   useEffect(() => { getApprasalList(); }, [selectedSubCompany]);

//   const fetchPending = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/wfm/employee-appraisal-rating-with-level-approvals-rh/?rh_emp_code=${selectedRH}`
//       );
//       setRows(res.data?.data || []);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load pending approvals.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openEmployee = (empCode) => {
//     setActiveEmp(empCode);
//     setShowModal(true);
//   };

//   const emp_options = [...rows]
//     .sort((a, b) => (a.employee?.emp_code || "").localeCompare(b.employee?.emp_code || ""))
//     .map((i) => ({
//       value: i.employee?.emp_code,
//       label: `${i.employee?.emp_code} - ${i.employee?.name}`,
//     }));

//   const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

//   const tableRef = useRef(null);
//   const handleDownloadAppraisalSheet = () => {
//     downloadAsExcel(tableRef, "users", `AppraisalSheet`);
//   };

//   // Helper function to calculate total ratings
//   const calcTotalRating = (ratingsArray, key) => {
//     if (!ratingsArray || ratingsArray.length === 0) return "-";
//     const total = ratingsArray.reduce((sum, current) => sum + Number(current[key] || 0), 0);
//     return total > 0 ? total : "-";
//   };

//   // Filter logic for Rating Period and Employee
//   const filteredRows = rows.filter((row) => {
//     const matchEmployee = employeeGet === "null" || employeeGet === null || row.employee?.emp_code === employeeGet;
//     const matchPeriod = ratingPeriod === "null" || row.appraisal?.rating_period === ratingPeriod;
//     return matchEmployee && matchPeriod;
//   });

//   return (
//     <>
//       <div className="attendance-history-cont">
//         <div className="attendance-subcont">
//           {/* Filters omitted for brevity, keeping them as they were in your code */}
//           <div className="field-cont">
//             <div className="field-cont-div">
//               {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
//               <select
//                 className="attendance-input-field width-20vw date-field"
//                 value={ratingPeriod}
//                 onChange={(e) => setRatingPeriod(e.target.value)}
//               >
//                 <option value="null">All Rating Periods</option>
//                 {ratingPeriodList
//                   ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
//                   .map((i, index) => (
//                     <option key={index} value={i.id}>
//                       {formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
//                     </option>
//                   ))}
//               </select>
//               <hr className="field-cont-hr" />
//             </div>

//             <div className="field-cont-div">
//               {loading ? <div className="spinner-vsmall"></div> : <Employee />}
//               <Select
//                 className="attendance-input-field width-20vw"
//                 options={[nullOptionEmp, ...emp_options]}
//                 value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
//                 placeholder="Select Employee Code"
//                 onChange={(opt) => setEmployeeGet(opt ? opt.value : null)}
//                 isClearable
//                 styles={CSSForFilterDropdown}
//               />
//               <hr className="field-cont-hr" />
//             </div>
//           </div>

//           <div className="btn-cont">
//             <button className="model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
//               <DownloadIcon />
//             </button>
//           </div>
//         </div>

//         <div className="table-css-white-background">
//           <div className="table-heading-flex">
//             <div className="repo-heading font-weight500 font-size-heading">
//               Appraisal Ratings
//             </div>
//           </div>
//           <table ref={tableRef} className="table-css">
//             <thead>
//               <tr className="custom-table-head-tr">
//                 <th className="align-left">Sr.no</th>
//                 <th className="align-center">Employee</th>
//                 {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
//                 <th className="align-center">Self Rating</th>
//                 <th className="align-center">Submission Status</th>

//                 <th className="align-center">Level 1 Rating</th>
//                 <th className="align-center">Level 1 Submission</th>
//                 <th className="align-center">Level 2 Rating</th>
//                 <th className="align-center">Level 2 Submission</th>
//                 <th className="align-center">Level 3 Rating</th>
//                 <th className="align-center">Level 3 Submission</th>

//                 <th className="align-center">Final Rating</th>
//                 <th className="align-center">Actions</th>
//               </tr>
//             </thead>
//             {loading ? (
//               <tbody><tr><td colSpan="13"><div className="spinner"></div></td></tr></tbody>
//             ) : (
//               <tbody>
//                 {filteredRows.map((row, index) => {
//                   const emp = row.employee;
//                   const appraisal = row.appraisal;
//                   const hierarchy = appraisal?.hierarchy || [];
//                   const levelWiseRatings = row.level_wise_ratings || [];

//                   const empTotal = calcTotalRating(row.ratings, 'employee_marks');

//                   // Since Role is null, extract purely by numeric Level
//                   const lvl1Data = levelWiseRatings.find(l => Number(l.level) === 1);
//                   const lvl2Data = levelWiseRatings.find(l => Number(l.level) === 2);
//                   const lvl3Data = levelWiseRatings.find(l => Number(l.level) === 3);

//                   // Calculate Final Rating
//                   let finalRating = "-";
//                   if (hierarchy.length > 0) {
//                     const maxLevel = Math.max(...hierarchy.map(h => Number(h.level)));
//                     const finalLevelData = levelWiseRatings.find(l => Number(l.level) === maxLevel);
//                     if (finalLevelData?.status === "approved") {
//                       finalRating = calcTotalRating(finalLevelData.ratings, 'marks_by_authority');
//                     }
//                   }

//                   // === THE FIX ===
//                   // Determine actual level of logged-in approver for THIS SPECIFIC ROW
//                   const myHierarchyMatch = hierarchy.find(h => String(h.approver) === String(selectedRH));
//                   const actualLevelForUser = myHierarchyMatch ? Number(myHierarchyMatch.level) : Number(level);

//                   // Lock out ONLY if a level STRICTLY GREATER than their actual level has approved
//                   const hasNextLevelApproved = levelWiseRatings.some(
//                     l => Number(l.level) > actualLevelForUser && l.status === "approved"
//                   );

//                   const renderSubmissionBlock = (levelData) => {
//                     if (!levelData) return "-";
//                     const displayName = levelData.approver_name || levelData.approver || "Approver";
//                     return (
//                       <p>
//                         By: {displayName} <br />
//                         Status: <span style={{ textTransform: 'capitalize', color: levelData.status === 'approved' ? 'green' : 'orange' }}>
//                           {levelData.status}
//                         </span>
//                       </p>
//                     );
//                   };

//                   return (
//                     <React.Fragment key={index}>
//                       <tr className="tr-border-bottom"><td colSpan="13"></td></tr>
//                       <tr className="custom-table-head-td">
//                         <td className="align-left">{index + 1}</td>
//                         <td className="align-center">
//                           {emp?.profile_pic ? (
//                             <CustomImageModal customStyle>
//                               <img src={`${IMAGE_URL}${emp.profile_pic}`} alt="profile" className="profile-img" />
//                             </CustomImageModal>
//                           ) : (
//                             <UserDefaultLogo user={{ name: emp?.name, profilepic: emp?.profile_pic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
//                           )}
//                           <p>{emp?.emp_code} - {emp?.name}</p>
//                         </td>

//                         {ratingPeriod === "null" && (
//                           <td className="align-left">
//                             {formattedDateLong(appraisal?.rating_period_start)} - {formattedDateLong(appraisal?.rating_period_end)}
//                           </td>
//                         )}

//                         <td className="align-center">{empTotal}</td>
//                         <td className="align-center">
//                           <p>Status: <br /> {row.ratings?.length > 0 ? "Submitted" : "Pending"}</p>
//                         </td>

//                         {/* Level 1 */}
//                         <td className="align-center">
//                           {lvl1Data?.status === "approved" ? calcTotalRating(lvl1Data.ratings, 'marks_by_authority') : "-"}
//                         </td>
//                         <td className="align-center">{renderSubmissionBlock(lvl1Data)}</td>

//                         {/* Level 2 */}
//                         <td className="align-center">
//                           {lvl2Data?.status === "approved" ? calcTotalRating(lvl2Data.ratings, 'marks_by_authority') : "-"}
//                         </td>
//                         <td className="align-center">{renderSubmissionBlock(lvl2Data)}</td>

//                         {/* Level 3 */}
//                         <td className="align-center">
//                           {lvl3Data?.status === "approved" ? calcTotalRating(lvl3Data.ratings, 'marks_by_authority') : "-"}
//                         </td>
//                         <td className="align-center">{renderSubmissionBlock(lvl3Data)}</td>

//                         {/* Final Rating */}
//                         <td className="align-center" style={{ fontWeight: 'bold' }}>{finalRating}</td>

//                         <td className="align-center">
//                           <button className={`${hasNextLevelApproved ? '' : 'model-edit-button'}`} onClick={() => openEmployee(emp?.emp_code)}>
//                             {hasNextLevelApproved ? (<BlueEye />) : (<UpdatePencil />)}
//                           </button>

//                           {showModal && activeEmp === emp?.emp_code && (
//                             <AppraisalApproverRatingModal
//                               show={showModal}
//                               onHide={() => {
//                                 setShowModal(false);
//                                 setActiveEmp(null);
//                               }}
//                               employeeCode={activeEmp}
//                               level={level}
//                               myEmpCode={selectedRH}
//                               onSuccess={fetchPending}
//                               isReadOnly={hasNextLevelApproved}
//                             />
//                           )}
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   );
//                 })}
//               </tbody>
//             )}
//           </table>
//         </div>
//       </div>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//     </>
//   );
// };

const AppraisalPendingApprovalsList = ({ level }) => {
  const [hodFilter, setHodFilter] = useState("null");
  const [rhFilterDropdown, setRhFilterDropdown] = useState("null");
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [activeEmp, setActiveEmp] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedRH, setSelectedRH] = useState(`${sessionStorage.getItem("emp_code")}`);
  const [selectedSubCompany, setSelectedSubCompany] = useState(`${sessionStorage.getItem("company_id")}`);

  const [buffer1, setBuffering1] = useState(true);
  const [ratingPeriod, setRatingPeriod] = useState("null");
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [employeeGet, setEmployeeGet] = useState("null");

  useEffect(() => { fetchPending(); }, [level, selectedRH]);

  const getApprasalList = async () => {
    setBuffering1(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) setRatingPeriod(activeSetup.id);
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false);
    }
  };

  useEffect(() => { getApprasalList(); }, [selectedSubCompany]);

  const fetchPending = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employee-appraisal-rating-with-level-approvals-rh/?rh_emp_code=${selectedRH}`
      );
      setRows(res.data?.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load pending approvals.");
    } finally {
      setLoading(false);
    }
  };

  const openEmployee = (empCode) => {
    setActiveEmp(empCode);
    setShowModal(true);
  };

  const emp_options = [...rows]
    .sort((a, b) => (a.employee?.emp_code || "").localeCompare(b.employee?.emp_code || ""))
    .map((i) => ({
      value: i.employee?.emp_code,
      label: `${i.employee?.emp_code} - ${i.employee?.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  // Unique HODs across all rows
  const hodOptions = useMemo(() => {
    const seen = new Map();
    rows.forEach((row) => {
      (row.appraisal?.hierarchy || []).forEach((h) => {
        if (h.role === "HOD" && !seen.has(h.approver)) {
          seen.set(h.approver, h.approver_name || h.approver);
        }
      });
    });
    return Array.from(seen.entries()).map(([value, label]) => ({
      value,
      label: `${value} - ${label}`,
    }));
  }, [rows]);

  // RH options — cascade based on selected HOD
  const rhOptions = useMemo(() => {
    const seen = new Map();
    rows.forEach((row) => {
      const hierarchy = row.appraisal?.hierarchy || [];
      const rhEntry = hierarchy.find((h) => h.role === "ReportingHead");
      if (!rhEntry) return;

      // agar HOD filter laga hai, to sirf uss HOD ke chain wale RH dikhao
      if (hodFilter !== "null") {
        const belongsToHOD = hierarchy.some(
          (h) => h.role === "HOD" && h.approver === hodFilter
        );
        if (!belongsToHOD) return;
      }

      if (!seen.has(rhEntry.approver)) {
        seen.set(rhEntry.approver, rhEntry.approver_name || rhEntry.approver);
      }
    });
    return Array.from(seen.entries()).map(([value, label]) => ({
      value,
      label: `${value} - ${label}`,
    }));
  }, [rows, hodFilter]);

  useEffect(() => {
    if (hodFilter !== "null") {
      const stillValid = rhOptions.some((o) => o.value === rhFilterDropdown);
      if (!stillValid) setRhFilterDropdown("null");
    }
  }, [hodFilter, rhOptions, rhFilterDropdown]);

  // const tableRef = useRef(null);
  // const handleDownloadAppraisalSheet = () => {
  //   downloadAsExcel(tableRef, "users", `AppraisalSheet`);
  // };

  // Helper function to calculate total ratings
  const calcTotalRating = (ratingsArray, key) => {
    if (!ratingsArray || ratingsArray.length === 0) return "-";
    const total = ratingsArray.reduce((sum, current) => sum + Number(current[key] || 0), 0);
    return total > 0 ? total : "-";
  };

  // ---- NEW: helpers only used for the export table ----
  const buildQuestionTypeMap = (row) => {
    const map = {};
    (row.ratings || []).forEach((r) => {
      map[r.id] = r.question?.type;
    });
    return map;
  };

  const calcCategorySums = (levelData, questionMap) => {
    if (!levelData || !levelData.ratings) {
      return { perf: "-", disc: "-", team: "-", total: "-" };
    }
    let perf = 0, disc = 0, team = 0;
    levelData.ratings.forEach((r) => {
      const type = questionMap[r.rating_id];
      const val = Number(r.marks_by_authority || 0);
      if (type === "PERFORMANCE") perf += val;
      else if (type === "DISCIPLINE AND BEHAVIOUR") disc += val;
      else if (type === "TEAM PERFORMANCE") team += val;
    });
    const total = perf + disc + team;
    return {
      perf: perf > 0 ? perf : 0,
      disc: disc > 0 ? disc : 0,
      team: team > 0 ? team : 0,
      total: total > 0 ? total : "-",
    };
  };
  // ------------------------------------------------------

  const tableRef = useRef(null);       // visible UI table (unchanged)
  const exportTableRef = useRef(null); // hidden table, used only for download

  const handleDownloadAppraisalSheet = () => {
    downloadAsExcelforRating(exportTableRef, "users", `AppraisalSheet`);
  };

  // Filter logic for Rating Period and Employee
  // const filteredRows = rows.filter((row) => {
  //   const matchEmployee = employeeGet === "null" || employeeGet === null || row.employee?.emp_code === employeeGet;
  //   const matchPeriod = ratingPeriod === "null" || row.appraisal?.rating_period === ratingPeriod;
  //   return matchEmployee && matchPeriod;
  // });

  const filteredRows = rows.filter((row) => {
    const hierarchy = row.appraisal?.hierarchy || [];
    const matchEmployee = employeeGet === "null" || employeeGet === null || row.employee?.emp_code === employeeGet;
    const matchPeriod = ratingPeriod === "null" || row.appraisal?.rating_period === ratingPeriod;

    const matchHOD =
      hodFilter === "null" ||
      hierarchy.some((h) => h.role === "HOD" && h.approver === hodFilter);

    const matchRH =
      rhFilterDropdown === "null" ||
      hierarchy.some((h) => h.role === "ReportingHead" && h.approver === rhFilterDropdown);

    return matchEmployee && matchPeriod && matchHOD && matchRH;
  });

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          {/* Filters omitted for brevity, keeping them as they were in your code */}
          <div className="field-cont">
            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw date-field"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option key={index} value={i.id}>
                      {formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                    </option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {loading ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={(opt) => setEmployeeGet(opt ? opt.value : null)}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Select
                className="attendance-input-field width-20vw"
                options={[{ value: "null", label: "Select HOD" }, ...hodOptions]}
                value={[{ value: "null", label: "Select HOD" }, ...hodOptions].find(o => o.value === hodFilter)}
                placeholder="Select HOD"
                onChange={(opt) => setHodFilter(opt ? opt.value : "null")}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Select
                className="attendance-input-field width-20vw"
                options={[{ value: "null", label: "Select RH" }, ...rhOptions]}
                value={[{ value: "null", label: "Select RH" }, ...rhOptions].find(o => o.value === rhFilterDropdown)}
                placeholder="Select RH"
                onChange={(opt) => setRhFilterDropdown(opt ? opt.value : "null")}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>


          </div>

          <div className="btn-cont">
            <button className="model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>

        {/* ================= VISIBLE UI TABLE — UNCHANGED ================= */}
        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Appraisal Ratings
            </div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Employee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Self Rating</th>
                <th className="align-center">Submission Status</th>

                <th className="align-center">Level 1 Rating</th>
                <th className="align-center">Level 1 Submission</th>
                <th className="align-center">Level 2 Rating</th>
                <th className="align-center">Level 2 Submission</th>
                <th className="align-center">Level 3 Rating</th>
                <th className="align-center">Level 3 Submission</th>

                <th className="align-center">Final Rating</th>
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {loading ? (
              <tbody><tr><td colSpan="13"><div className="spinner"></div></td></tr></tbody>
            ) : (
              <tbody>
                {filteredRows.map((row, index) => {
                  const emp = row.employee;
                  const appraisal = row.appraisal;
                  const hierarchy = appraisal?.hierarchy || [];
                  const levelWiseRatings = row.level_wise_ratings || [];

                  const empTotal = calcTotalRating(row.ratings, 'employee_marks');

                  const lvl1Data = levelWiseRatings.find(l => Number(l.level) === 1);
                  const lvl2Data = levelWiseRatings.find(l => Number(l.level) === 2);
                  const lvl3Data = levelWiseRatings.find(l => Number(l.level) === 3);

                  let finalRating = "-";
                  if (hierarchy.length > 0) {
                    const maxLevel = Math.max(...hierarchy.map(h => Number(h.level)));
                    const finalLevelData = levelWiseRatings.find(l => Number(l.level) === maxLevel);
                    if (finalLevelData?.status === "approved") {
                      finalRating = calcTotalRating(finalLevelData.ratings, 'marks_by_authority');
                    }
                  }

                  const myHierarchyMatch = hierarchy.find(h => String(h.approver) === String(selectedRH));
                  const actualLevelForUser = myHierarchyMatch ? Number(myHierarchyMatch.level) : Number(level);

                  const hasNextLevelApproved = levelWiseRatings.some(
                    l => Number(l.level) > actualLevelForUser && l.status === "approved"
                  );

                  const renderSubmissionBlock = (levelData) => {
                    if (!levelData) return "-";
                    const displayName = levelData.approver_name || levelData.approver || "Approver";
                    return (
                      <p>
                        By: {displayName} <br />
                        Status: <span style={{ textTransform: 'capitalize', color: levelData.status === 'approved' ? 'green' : 'orange' }}>
                          {levelData.status}
                        </span>
                      </p>
                    );
                  };

                  return (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom"><td colSpan="13"></td></tr>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">
                          {emp?.profile_pic ? (
                            <CustomImageModal customStyle>
                              <img src={`${IMAGE_URL}${emp.profile_pic}`} alt="profile" className="profile-img" />
                            </CustomImageModal>
                          ) : (
                            <UserDefaultLogo user={{ name: emp?.name, profilepic: emp?.profile_pic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                          )}
                          <p>{emp?.emp_code} - {emp?.name}</p>
                        </td>

                        {ratingPeriod === "null" && (
                          <td className="align-left">
                            {formattedDateLong(appraisal?.rating_period_start)} - {formattedDateLong(appraisal?.rating_period_end)}
                          </td>
                        )}

                        <td className="align-center">{empTotal}</td>
                        <td className="align-center">
                          <p>Status: <br /> {row.ratings?.length > 0 ? "Submitted" : "Pending"}</p>
                        </td>

                        <td className="align-center">
                          {lvl1Data?.status === "approved" ? calcTotalRating(lvl1Data.ratings, 'marks_by_authority') : "-"}
                        </td>
                        <td className="align-center">{renderSubmissionBlock(lvl1Data)}</td>

                        <td className="align-center">
                          {lvl2Data?.status === "approved" ? calcTotalRating(lvl2Data.ratings, 'marks_by_authority') : "-"}
                        </td>
                        <td className="align-center">{renderSubmissionBlock(lvl2Data)}</td>

                        <td className="align-center">
                          {lvl3Data?.status === "approved" ? calcTotalRating(lvl3Data.ratings, 'marks_by_authority') : "-"}
                        </td>
                        <td className="align-center">{renderSubmissionBlock(lvl3Data)}</td>

                        <td className="align-center" style={{ fontWeight: 'bold' }}>{finalRating}</td>

                        <td className="align-center">
                          <button className={`${hasNextLevelApproved ? '' : 'model-edit-button'}`} onClick={() => openEmployee(emp?.emp_code)}>
                            {hasNextLevelApproved ? (<BlueEye />) : (<UpdatePencil />)}
                          </button>

                          {showModal && activeEmp === emp?.emp_code && (
                            <AppraisalApproverRatingModal
                              show={showModal}
                              onHide={() => {
                                setShowModal(false);
                                setActiveEmp(null);
                              }}
                              employeeCode={activeEmp}
                              level={level}
                              myEmpCode={selectedRH}
                              onSuccess={fetchPending}
                              isReadOnly={hasNextLevelApproved}
                            />
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>

        {/* ================= HIDDEN EXPORT-ONLY TABLE — mockup structure ================= */}
        <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
          <table ref={exportTableRef}>
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>

                <th colSpan={2} style={{ fontWeight: "bold", textAlign: "center" }}>
                  Self Rating
                </th>

                <th colSpan={5} style={{ fontWeight: "bold", textAlign: "center" }}>
                  Level 1
                </th>

                <th colSpan={5} style={{ fontWeight: "bold", textAlign: "center" }}>
                  Level 2
                </th>

                <th colSpan={5} style={{ fontWeight: "bold", textAlign: "center" }}>
                  Level 3 (Final)
                </th>

                <th></th>
              </tr>
              <tr>
                <th>Sr.no</th>
                <th>Employee Code</th>
                <th>Employee Name</th>

                <th>Total (/50)</th>
                <th>Given</th>

                <th>Performance (/50)</th>
                <th>Discipline (/20)</th>
                <th>Team Performance (/30)</th>
                <th>Total</th>
                <th>Approver</th>

                <th>Performance (/50)</th>
                <th>Discipline (/20)</th>
                <th>Team Performance (/30)</th>
                <th>Total</th>
                <th>Approver</th>

                <th>Performance (Final) (/50)</th>
                <th>Discipline (Final) (/20)</th>
                <th>Team Performance (Final) (/30)</th>
                <th>Total</th>
                <th>Approver</th>

                <th>Final Rating</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row, index) => {
                const emp = row.employee;
                const appraisal = row.appraisal;
                const hierarchy = appraisal?.hierarchy || [];
                const levelWiseRatings = row.level_wise_ratings || [];
                const questionMap = buildQuestionTypeMap(row);

                const empTotal = calcTotalRating(row.ratings, 'employee_marks');

                const lvl1Data = levelWiseRatings.find(l => Number(l.level) === 1);
                const lvl2Data = levelWiseRatings.find(l => Number(l.level) === 2);
                const lvl3Data = levelWiseRatings.find(l => Number(l.level) === 3);

                const lvl1Sums = lvl1Data?.status === "approved" ? calcCategorySums(lvl1Data, questionMap) : { perf: "-", disc: "-", team: "-", total: "-" };
                const lvl2Sums = lvl2Data?.status === "approved" ? calcCategorySums(lvl2Data, questionMap) : { perf: "-", disc: "-", team: "-", total: "-" };
                const lvl3Sums = lvl3Data?.status === "approved" ? calcCategorySums(lvl3Data, questionMap) : { perf: "-", disc: "-", team: "-", total: "-" };

                let finalRating = "-";
                if (hierarchy.length > 0) {
                  const maxLevel = Math.max(...hierarchy.map(h => Number(h.level)));
                  const finalLevelData = levelWiseRatings.find(l => Number(l.level) === maxLevel);
                  if (finalLevelData?.status === "approved") {
                    finalRating = calcTotalRating(finalLevelData.ratings, 'marks_by_authority');
                  }
                }

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{emp?.emp_code}</td>
                    <td>{emp?.name}</td>

                    <td>50</td>
                    <td>{empTotal}</td>

                    <td>{lvl1Sums.perf}</td>
                    <td>{lvl1Sums.disc}</td>
                    <td>{lvl1Sums.team}</td>
                    <td>{lvl1Sums.total}</td>
                    <td>{lvl1Data?.approver_name || lvl1Data?.approver || "-"}</td>

                    <td>{lvl2Sums.perf}</td>
                    <td>{lvl2Sums.disc}</td>
                    <td>{lvl2Sums.team}</td>
                    <td>{lvl2Sums.total}</td>
                    <td>{lvl2Data?.approver_name || lvl2Data?.approver || "-"}</td>

                    <td>{lvl3Sums.perf}</td>
                    <td>{lvl3Sums.disc}</td>
                    <td>{lvl3Sums.team}</td>
                    <td>{lvl3Sums.total}</td>
                    <td>{lvl3Data?.approver_name || lvl3Data?.approver || "-"}</td>

                    <td>{finalRating}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};
//-----------------------------------------not used

const AppraisalFormsTableRH = () => {

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [ratingPeriod, setRatingPeriod] = useState("null");
  const [selectedRH, setSelectedRH] = useState(
    `${sessionStorage.getItem("emp_code")}`
  );
  const [selectedSubCompany, setSelectedSubCompany] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [employeeList, setEmployeeList] = useState([]);
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [applraisalFormList, setApplraisalFormList] = useState([]);



  const getRatingPeriod = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) {
        setRatingPeriod(activeSetup.id);
      }
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api Start ***********

  const getEmpList = async () => {
    setBuffering2(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employeedetails-byrh/${selectedRH}/${active}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering2(false); //buffering logic // End Buffering
    }
  };

  const getApplraisalFormListRH = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${selectedSubCompany}/null/${selectedRH}/${employeeGet}/${ratingPeriod}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getRatingPeriod();
    getEmpList();
  }, [selectedSubCompany, selectedRH, active]);

  useEffect(() => {
    getApplraisalFormListRH();
  }, [selectedSubCompany, selectedRH, employeeGet, ratingPeriod]);

  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedRH === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };

  const emp_options = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw   date-field"
                type="text"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option value={i.id}>{formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>
          </div>

          <div className="btn-cont">
            <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>
        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">Appraisal Ratings
              {ratingPeriod !== "null" && (() => {
                const selectedPeriod = ratingPeriodList.find(r => r.id.toString() === ratingPeriod);
                return selectedPeriod
                  ? ` for ${formattedDateLong(selectedPeriod.rating_period_start)} - ${formattedDateLong(selectedPeriod.rating_period_end)}`
                  : '';
              })()}
              ({applraisalFormList.length}/{employeeList.length})</div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Employee Self Rating</th>
                <th className="align-center">Employee Submission</th>
                <th className="align-center">Reporting Head Rating</th>
                <th className="align-center">Reporting Head Submission</th>
                {/* <th className="align-center">HOD Rating</th>
                <th className="align-center">HOD Submission</th>
                <th className="align-center">Admin Rating</th>
                <th className="align-center">Admin Submission</th>
                <th className="align-center">Final Rating</th> */}
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {applraisalFormList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {i.profilepic &&
                          <>
                            <CustomImageModal customStyle>
                              {i.profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                          </>
                        }
                        <p>{i.emp_code}-{i.name}</p>
                      </td>
                      {ratingPeriod === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                        <br />
                        {i.is_active === true || i.is_active === 'True' ?
                          <button className="priority-button color-tab-green">
                            Current
                          </button>
                          : null}
                      </td>}

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            {i.total_emp}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            < p > Submited At :
                              <br />
                              {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}</p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.rh_update_datetime ?
                          <>
                            {i.total_rh}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.rh_update_datetime ?
                          <>
                            <p>By : {i.rh_update_by}
                              <br />
                              At : {i.rh_update_datetime ? formatDateTime(i.rh_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      {/* <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            {i.total_hod}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            <p>By : {i.hod_update_by}
                              <br />
                              At : {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            {i.total_admin}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            <p>By : {i.admin_update_by}
                              {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.final_rating || '-'}
                      </td> */}

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <ViewAppraisalDetailsByRH i={i} />
                          :
                          <UploadAppraisalDetailsByRH i={i} getDepartmentAppraisalData={getApplraisalFormListRH} />
                        }
                      </td>

                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const AppraisalFormsTableHOD = () => {

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [ratingPeriod, setRatingPeriod] = useState("null");
  const [selectedDepartment, setDepartment] = useState(
    `${sessionStorage.getItem("department")}`
  );
  const [selectedSubCompany, setSelectedSubCompany] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [employeeList, setEmployeeList] = useState([]);
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [applraisalFormList, setApplraisalFormList] = useState([]);


  const getRatingPeriod = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) {
        setRatingPeriod(activeSetup.id);
      }
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api Start ***********

  const getEmpList = async () => {
    setBuffering2(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employeedetailsbydepartment/${selectedDepartment}/${active}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering2(false); //buffering logic // End Buffering
    }
  };

  const getApplraisalFormListHOD = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${selectedSubCompany}/${selectedDepartment}/null/${employeeGet}/${ratingPeriod}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getRatingPeriod();
    getEmpList();
  }, [
    selectedSubCompany,
    selectedDepartment,
    active,
  ]);

  useEffect(() => {
    getApplraisalFormListHOD();
  }, [selectedSubCompany, selectedDepartment, employeeGet, ratingPeriod]);


  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedDepartment === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };

  const emp_options = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw   date-field"
                type="text"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option value={i.id}>{formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

          </div>
          <div className="btn-cont">
            <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">Appraisal Ratings
              {ratingPeriod !== "null" && (() => {
                const selectedPeriod = ratingPeriodList.find(r => r.id.toString() === ratingPeriod);
                return selectedPeriod
                  ? ` for ${formattedDateLong(selectedPeriod.rating_period_start)} - ${formattedDateLong(selectedPeriod.rating_period_end)}`
                  : '';
              })()}
              ({applraisalFormList.length}/{employeeList.length})</div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Employee Self Rating</th>
                <th className="align-center">Employee Submission</th>
                <th className="align-center">HOD Rating</th>
                <th className="align-center">HOD Submission</th>
                {/* <th className="align-center">Admin Rating</th>
                <th className="align-center">Admin Submission</th>
                <th className="align-center">Final Rating</th> */}
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {applraisalFormList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {i.profilepic &&
                          <>
                            <CustomImageModal customStyle>
                              {i.profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                          </>
                        }
                        <p>{i.emp_code}-{i.name}</p>
                      </td>
                      {ratingPeriod === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                        <br />
                        {i.is_active === true || i.is_active === 'True' ?
                          <button className="priority-button color-tab-green">
                            Current
                          </button>
                          : null}
                      </td>}

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            {i.total_emp}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            < p > Submited At :
                              <br />
                              {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}</p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            {i.total_hod}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            <p>By : {i.hod_update_by}
                              <br />
                              At : {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      {/* <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            {i.total_admin}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            <p>By : {i.admin_update_by}
                              {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.final_rating || '-'}
                      </td> */}
                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <ViewAppraisalDetailsByHOD i={i} />
                          :
                          <UploadAppraisalDetailsByHOD i={i} getDepartmentAppraisalData={getApplraisalFormListHOD} />
                        }
                      </td>

                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const AppraisalFormsTableRHHOD = () => {
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [ratingPeriod, setRatingPeriod] = useState("null");
  const [selectedDepartment, setDepartment] = useState(
    `${sessionStorage.getItem("department")}`
  );
  const [selectedSubCompany, setSelectedSubCompany] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [employeeList, setEmployeeList] = useState([]);
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [applraisalFormList, setApplraisalFormList] = useState([]);


  const getRatingPeriod = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) {
        setRatingPeriod(activeSetup.id);
      }
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api Start ***********

  const getEmpList = async () => {
    setBuffering2(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employeedetailsbydepartment/${selectedDepartment}/${active}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering2(false);
    }
  };

  const getApplraisalFormListHOD = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${selectedSubCompany}/${selectedDepartment}/null/${employeeGet}/${ratingPeriod}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getRatingPeriod();
    getEmpList();
  }, [
    selectedSubCompany,
    selectedDepartment,
    active,
  ]);

  useEffect(() => {
    getApplraisalFormListHOD();
  }, [selectedSubCompany, selectedDepartment, employeeGet, ratingPeriod]);

  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedDepartment === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };

  const emp_options = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw   date-field"
                type="text"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option value={i.id}>{formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)}</option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

          </div>
          <div className="btn-cont">
            <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>


        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">Appraisal Ratings
              {ratingPeriod !== "null" && (() => {
                const selectedPeriod = ratingPeriodList.find(r => r.id.toString() === ratingPeriod);
                return selectedPeriod
                  ? ` for ${formattedDateLong(selectedPeriod.rating_period_start)} - ${formattedDateLong(selectedPeriod.rating_period_end)}`
                  : '';
              })()}
              ({applraisalFormList.length}/{employeeList.length})</div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Employee Self Rating</th>
                <th className="align-center">Employee Submission</th>
                <th className="align-center">Reporting Head Rating</th>
                <th className="align-center">Reporting Head Submission</th>
                <th className="align-center">HOD Rating</th>
                <th className="align-center">HOD Submission</th>
                {/* <th className="align-center">Admin Rating</th>
                <th className="align-center">Admin Submission</th>
                <th className="align-center">Final Rating</th> */}
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {applraisalFormList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {i.profilepic &&
                          <>
                            <CustomImageModal customStyle>
                              {i.profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                          </>
                        }
                        <p>{i.emp_code}-{i.name}</p>
                      </td>
                      {ratingPeriod === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                        <br />
                        {i.is_active === true || i.is_active === 'True' ?
                          <button className="priority-button color-tab-green">
                            Current
                          </button>
                          : null}
                      </td>}

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            {i.total_emp}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            < p > Submited At :
                              <br />
                              {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}</p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.rh_update_datetime ?
                          <>
                            {i.total_rh}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.rh_update_datetime ?
                          <>
                            <p>By : {i.rh_update_by}
                              <br />
                              At : {i.rh_update_datetime ? formatDateTime(i.rh_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            {i.total_hod}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            <p>By : {i.hod_update_by}
                              <br />
                              At : {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      {/* <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            {i.total_admin}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            <p>By : {i.admin_update_by}
                              {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                            </p>
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.final_rating || '-'}
                      </td> */}
                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <ViewAppraisalDetailsByRHHOD i={i} />
                          :
                          <UploadAppraisalDetailsByRHHOD i={i} getDepartmentAppraisalData={getApplraisalFormListHOD} />
                        }
                      </td>

                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};


const AppraisalFormsTableHODAdmin = () => {
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);
  const [buffer3, setBuffering3] = useState(true);
  const [timeStampView, setTimeStampView] = useState(false);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [ratingPeriod, setRatingPeriod] = useState("null");

  const [selectedDepartment, setDepartment] = useState(`null`);

  const [selectedSubCompany, setSelectedSubCompany] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [departmentname, setDepartmentname] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [applraisalFormList, setApplraisalFormList] = useState([]);



  // *********** Employee Details Api Start ***********

  const getRatingPeriod = async () => {
    setBuffering1(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) {
        setRatingPeriod(activeSetup.id);
      }
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);
    }
  };



  const getDepartment = async () => {
    try {
      setBuffering2(true)
      const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedSubCompany || 'null'}/${active}/`);
      setDepartmentname(dep.data)
    } catch (err) {
    } finally {
      setBuffering2(false)
    }
  };

  // *********** Employee Details Api Start ***********

  const getEmpList = async () => {
    setBuffering3(true)
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/ /${active}/${selectedDepartment}/`);
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering3(false);
    }
  };

  const getApplraisalFormListAdmin = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${selectedSubCompany}/${selectedDepartment}/null/${employeeGet}/${ratingPeriod}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
      // setApplraisalFormList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getRatingPeriod();
    getEmpList();
    getDepartment();
  }, [selectedSubCompany, active]);

  useEffect(() => {
    getApplraisalFormListAdmin();
  }, [employeeGet, selectedDepartment, selectedSubCompany, ratingPeriod]);


  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedDepartment === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };

  const emp_options = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };
  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          <div className="field-cont">
            {PERMISSION_AUTHORITY ?
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedSubCompany}
                  onChange={(e) => setSelectedSubCompany(e.target.value)}
                >
                  {/* <option value="">All Sub Companies</option> */}
                  {SUB_COMPANIES.sort((a, b) => a.title - b.title).map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))}
                  ;
                </select>
                <hr className="field-cont-hr" />
              </div>
              : null
            }

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw   date-field"
                type="text"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option value={i.id}>{formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <CircularGrid />}
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="null">All Department</option>
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer3 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>


          </div>

          <div className="btn-cont">
            <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">Appraisal Ratings
              {ratingPeriod !== "null" && (() => {
                const selectedPeriod = ratingPeriodList.find(r => r.id.toString() === ratingPeriod);
                return selectedPeriod
                  ? ` for ${formattedDateLong(selectedPeriod.rating_period_start)} - ${formattedDateLong(selectedPeriod.rating_period_end)}`
                  : '';
              })()}
              ({applraisalFormList.length}/{employeeList.length})</div>
            <div className="filter-showing">
              <div className="flex-row ">
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  Time Stamps {timeStampView ? "Shown" : "Hidden"} : {" "}
                </label>
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={timeStampView}
                    onChange={() => setTimeStampView(!timeStampView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
              </div>
            </div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Employee Self Rating</th>
                {timeStampView ?
                  <th className="align-center">Employee TimeStamp</th>
                  : null
                }
                <th className="align-center">HOD Rating</th>
                <th className="align-center">HOD Submission</th>
                {timeStampView ?
                  <th className="align-center">HOD TimeStamp</th>
                  : null
                }
                <th className="align-center">Admin Rating</th>
                <th className="align-center">Admin Submission</th>
                {timeStampView ?
                  <th className="align-center">Admin TimeStamp</th>
                  : null
                }
                <th className="align-center">Final Rating</th>
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {applraisalFormList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {i.profilepic &&
                          <>
                            <CustomImageModal customStyle>
                              {i.profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                          </>
                        }
                        <p>{i.emp_code}-{i.name}</p>
                      </td>
                      {ratingPeriod === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                        <br />
                        {i.is_active === true || i.is_active === 'True' ?
                          <button className="priority-button color-tab-green">
                            Current
                          </button>
                          : null}
                      </td>}

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            {i.total_emp}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.emp_update_datetime ?
                            <>
                              {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }

                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            {i.total_hod}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_by ?
                          <>
                            {i.hod_update_by}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.hod_update_datetime ?
                            <>
                              {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }

                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            {i.total_admin}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_by ?
                          <>
                            {i.admin_update_by}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.admin_update_datetime ?
                            <>
                              {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }

                      <td className="align-center">
                        {i.final_rating || '-'}
                      </td>

                      <td className="align-center">
                        {/* {i.admin_update_datetime ?
                          <ViewAppraisalDetailsHODAdmin i={i} />
                          :
                          <UploadAppraisalDetailsByHODAdmin i={i} getDepartmentAppraisalData={getApplraisalFormListAdmin} />
                        } */}
                        <UploadAppraisalDetailsByHODAdmin i={i} getDepartmentAppraisalData={getApplraisalFormListAdmin} />
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const AppraisalFormsTableRHHODAdmin = () => {
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);
  const [buffer3, setBuffering3] = useState(true);
  const [timeStampView, setTimeStampView] = useState(false);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [ratingPeriod, setRatingPeriod] = useState("null");
  const [selectedDepartment, setDepartment] = useState(`null`);

  const [selectedSubCompany, setSelectedSubCompany] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [departmentname, setDepartmentname] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [ratingPeriodList, setRatingPeriodList] = useState([]);
  const [applraisalFormList, setApplraisalFormList] = useState([]);



  // *********** Employee Details Api Start ***********

  const getRatingPeriod = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
      const activeSetup = res.data.find(r => r.is_active);
      if (activeSetup) {
        setRatingPeriod(activeSetup.id);
      }
      setRatingPeriodList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  const getDepartment = async () => {
    try {
      setBuffering2(true)
      const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedSubCompany || 'null'}/${active}/`);
      setDepartmentname(dep.data)
    } catch (err) {
      // handleErrorToast(err)
    } finally {
      setBuffering2(false)
    }
  };

  const getEmpList = async () => {
    setBuffering3(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`);
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering3(false); //buffering logic // End Buffering
    }
  };


  const getApplraisalFormListAdmin = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/appraisals/${selectedSubCompany}/${selectedDepartment}/null/${employeeGet}/${ratingPeriod}/`
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setApplraisalFormList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getRatingPeriod();
    getEmpList();
    getDepartment();
  }, [selectedSubCompany, active]);

  useEffect(() => {
    getApplraisalFormListAdmin();
  }, [employeeGet, selectedDepartment, selectedSubCompany, ratingPeriod]);


  const tableRef = useRef(null);
  const handleDownloadAppraisalSheet = () => {
    downloadAsExcel(tableRef, "users",
      selectedDepartment === "" ? `AppraisalSheet` :
        `AppraisalSheet`);
  };

  const emp_options = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-subcont">
          <div className="field-cont">

            {PERMISSION_AUTHORITY ?
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedSubCompany}
                  onChange={(e) => setSelectedSubCompany(e.target.value)}
                >
                  {/* <option value="">All Sub Companies</option> */}
                  {SUB_COMPANIES.sort((a, b) => a.title - b.title).map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))}
                  ;
                </select>
                <hr className="field-cont-hr" />
              </div>
              : null
            }

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Calender />}
              <select
                className="attendance-input-field width-20vw   date-field"
                type="text"
                value={ratingPeriod}
                onChange={(e) => setRatingPeriod(e.target.value)}
              >
                <option value="null">All Rating Periods</option>
                {ratingPeriodList
                  ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                  .map((i, index) => (
                    <option value={i.id}>{formattedDateLong(i.rating_period_start)}-{formattedDateLong(i.rating_period_end)}</option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <CircularGrid />}
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="null">All Department</option>
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer3 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === employeeGet) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

          </div>

          <div className="btn-cont">
            <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadAppraisalSheet}>
              <DownloadIcon />
            </button>
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">Appraisal Ratings
              {ratingPeriod !== "null" && (() => {
                const selectedPeriod = ratingPeriodList.find(r => r.id.toString() === ratingPeriod);
                return selectedPeriod
                  ? ` for ${formattedDateLong(selectedPeriod.rating_period_start)} - ${formattedDateLong(selectedPeriod.rating_period_end)}`
                  : '';
              })()}
              ({applraisalFormList.length}/{employeeList.length})</div>
            <div className="filter-showing">
              <div className="flex-row ">
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  Time Stamps {timeStampView ? "Shown" : "Hidden"} : {" "}
                </label>
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={timeStampView}
                    onChange={() => setTimeStampView(!timeStampView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
              </div>
            </div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee</th>
                {ratingPeriod === "null" && <th className="align-center">Rating Period</th>}
                <th className="align-center">Employee Self Rating</th>
                {timeStampView ?
                  <th className="align-center">Employee TimeStamp</th>
                  : null
                }
                <th className="align-center">Reporting Head Rating</th>
                <th className="align-center">Reporting Head Submission</th>
                {timeStampView ?
                  <th className="align-center">Reporting Head TimeStamp</th>
                  : null
                }
                <th className="align-center">HOD Rating</th>
                <th className="align-center">HOD Submission</th>
                {timeStampView ?
                  <th className="align-center">HOD TimeStamp</th>
                  : null
                }
                <th className="align-center">Admin Rating</th>
                <th className="align-center">Admin Submission</th>

                {timeStampView ?
                  <th className="align-center">Admin TimeStamp</th>
                  : null
                }
                <th className="align-center">Final Rating</th>
                <th className="align-center">Actions</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {applraisalFormList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {i.profilepic &&
                          <>
                            <CustomImageModal customStyle>
                              {i.profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                          </>
                        }
                        <p>{i.emp_code}-{i.name}</p>
                      </td>
                      {ratingPeriod === "null" && <td className="align-left">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                        <br />
                        {i.is_active === true || i.is_active === 'True' ?
                          <button className="priority-button color-tab-green">
                            Current
                          </button>
                          : null}
                      </td>}

                      <td className="align-center">
                        {i.emp_update_datetime ?
                          <>
                            {i.total_emp}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.emp_update_datetime ?
                            <>
                              {i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }
                      <td className="align-center">
                        {i.rh_update_datetime ?
                          <>
                            {i.total_rh}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.rh_update_by ?
                          <>
                            {i.rh_update_by}
                          </>
                          : "-"
                        }
                      </td>
                      {timeStampView ?
                        <td className="align-center">
                          {i.rh_update_datetime ?
                            <>
                              {i.rh_update_datetime ? formatDateTime(i.rh_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }
                      <td className="align-center">
                        {i.hod_update_datetime ?
                          <>
                            {i.total_hod}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.hod_update_by ?
                          <>
                            {i.hod_update_by}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.hod_update_datetime ?
                            <>
                              {i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }
                      <td className="align-center">
                        {i.admin_update_datetime ?
                          <>
                            {i.total_admin}
                          </>
                          : "-"
                        }
                      </td>

                      <td className="align-center">
                        {i.admin_update_by ?
                          <>
                            {i.admin_update_by}
                          </>
                          : "-"
                        }
                      </td>

                      {timeStampView ?
                        <td className="align-center">
                          {i.admin_update_datetime ?
                            <>
                              {i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : null}
                            </>
                            : "-"
                          }
                        </td>
                        : null
                      }
                      <td className="align-center">
                        {i.final_rating || '-'}
                      </td>

                      <td className="align-center">
                        {/* {i.admin_update_datetime ?
                          <ViewAppraisalDetailsRHHODAdmin i={i} />
                          :
                          <UploadAppraisalDetailsByRHHODAdmin i={i} getDepartmentAppraisalData={getApplraisalFormListAdmin} />
                        } */}
                        <UploadAppraisalDetailsByRHHODAdmin i={i} getDepartmentAppraisalData={getApplraisalFormListAdmin} />
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

//-----------------------------------------not used


// const AppraisalParameterType = () => {

//   const [buffer, setBuffering] = useState(false);
//   const [appraisalParameterType, setAppraisalParameterType] = useState([]);
//   const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
//   const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

//   const [searchQuery, setSearchQuery] = useState("");
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };



//   const getAppraisalTypes = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-dynamic-parametertype-by-subcompany/${toggleCompany}/`);
//       setAppraisalParameterType(res.data);
//     } catch (error) {
//       handleErrorToast(error)
//     } finally {
//       setBuffering(false);
//     }
//   }

//   useEffect(() => {
//     getAppraisalTypes();
//   }, [toggleCompany]);

//   return (
//     <div>
//       <div className="table-css-white-background">
//         <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
//           <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
//             <div className="repo-heading font-weight500 font-size-heading">
//               Appraisal Parameter Types
//             </div>
//             <div className="field-cont">
//               {SUPER_ADMIN && <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
//                 <Office />
//                 <select
//                   value={toggleCompany}
//                   onChange={(e) => setToggleCompany(e.target.value)}
//                   className="dropdown font-size-subheading  "
//                   style={{ cursor: "pointer" }}
//                 >
//                   <option value="null">Select SubCompany</option>
//                   {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
//                 </select>
//               </div>}
//               <div title='Search' className="table-searchh">
//                 <div>
//                   <SearchSmall />
//                   <input
//                     placeholder="Search"
//                     className="navbar-inputt font-weight400  font-size-text"
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                   />
//                 </div>
//               </div>
//               <AddAppraisalType getAppraisalTypes={getAppraisalTypes} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
//             </div>
//           </div>
//           {/* <div className='table-box  scroll-container-table' style={{ width: "100%" }}> */}
//           <table className="table-css" >
//             <thead className="table-heading">
//               <tr className="custom-table-head-tr">
//                 <th className="table-heading-text text-left-sr">S. No.</th>
//                 <th className="table-heading-text text-center">Code</th>
//                 <th className="table-heading-text text-center">Name</th>
//                 <th className="table-heading-text text-center">Description</th>
//                 {toggleCompany === 'null' && <th className="table-heading-text text-center">Sub Company</th>}
//                 <th className="table-heading-text text-center">Created At</th>
//                 <th className="table-heading-text text-center">Last Update</th>
//                 <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
//               </tr>
//             </thead>
//             {buffer ? (
//               <div className="spinner-bgdatil"></div>//buffering logic
//             ) : (
//               <tbody>
//                 {appraisalParameterType
//                   ?.filter((e) =>
//                     (e.other_name || "").toLowerCase().includes(searchQuery.toLowerCase())
//                   )
//                   .sort((a, b) =>
//                     a.other_name?.localeCompare(b.other_name, "en", {
//                       ignorePunctuation: true,
//                     })
//                   )
//                   .sort((a, b) =>
//                     a.sub_company_title?.localeCompare(b.sub_company_title, "en", {
//                       ignorePunctuation: true,
//                     })
//                   )
//                   .map((i, index) => (
//                     <React.Fragment key={index}>
//                       <tr className="custom-table-head-td ">
//                         <td className="table-body">{index + 1}</td>
//                         <td className="table-body text-center ">{i.code}</td>
//                         <td className="table-body text-center ">{i.name}</td>
//                         <td className="table-body text-center ">{i.description}</td>
//                         {toggleCompany === 'null' && <td className="table-body text-center">{i.sub_company_title}</td>}
//                         <td className="table-body align-center">
//                           {formatDateTime(i?.created_at).longdate}
//                           <br />
//                           <small>{formatDateTime(i?.created_at).time}</small>
//                         </td>


//                         <td className="table-body align-center">
//                           <>
//                             {i.updated_by &&
//                               <>
//                                 <CustomImageModal customStyle>
//                                   {i.updated_by_profilepic ? (
//                                     <img
//                                       src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
//                                       alt="profile" className="profile-img"
//                                     />
//                                   ) : (
//                                     <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
//                                   )}
//                                 </CustomImageModal>
//                                 <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
//                                 {/* At- */}
//                               </>
//                             }
//                             {i.updated_by ?
//                               <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
//                               :
//                               <>
//                                 {i?.updated_at && formatDateTime(i?.updated_at).longdate}
//                                 <br />
//                                 <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
//                               </>}
//                           </>
//                         </td>
//                         <td className="table-body text-right" style={{ justifyContent: 'right' }}>

//                           <div className='flex-row justify-end'>
//                             <UpdateAppraisalType
//                               i={i}
//                               getAppraisalTypes={getAppraisalTypes}
//                               SUB_COMPANIES={SUB_COMPANIES}
//                               SUPER_ADMIN={SUPER_ADMIN}
//                             />
//                             <DeleteAppraisalType
//                               i={i}
//                               getAppraisalTypes={getAppraisalTypes} />
//                           </div>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//               </tbody>
//             )}
//           </table>
//           {/* </div> */}
//         </div>
//       </div>
//     </div>
//   )
// }

const AppraisalParameterType = () => {

  const [buffer, setBuffering] = useState(false);
  const [appraisalType, setAppraisalType] = useState([]);
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getAppraisalTypes = async () => {
    try {
      setBuffering(true);
      const url = toggleCompany && toggleCompany !== 'null'
        ? `${BASE_URL}/wfm/appraisal-types-by-subcompany/${toggleCompany}/`
        : `${BASE_URL}/wfm/appraisal-types/`;
      const res = await axios.get(url);
      setAppraisalType(res.data);
    } catch (error) {
      handleErrorToast(error)
    } finally {
      setBuffering(false);
    }
  }

  useEffect(() => {
    getAppraisalTypes();
  }, [toggleCompany]);

  return (
    <div>
      <div className="table-css-white-background">
        <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
          <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
            <div className="repo-heading font-weight500 font-size-heading">
              Appraisal Types
            </div>
            <div className="field-cont">
              {SUPER_ADMIN && <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
                <Office />
                <select
                  value={toggleCompany}
                  onChange={(e) => setToggleCompany(e.target.value)}
                  className="dropdown font-size-subheading  "
                  style={{ cursor: "pointer" }}
                >
                  <option value="null">Select SubCompany</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id} key={company.id}>{company.title}</option>))}
                </select>
              </div>}
              <div title='Search' className="table-searchh">
                <div>
                  <SearchSmall />
                  <input
                    placeholder="Search"
                    className="navbar-inputt font-weight400  font-size-text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
              <AddAppraisalType getAppraisalTypes={getAppraisalTypes} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
            </div>
          </div>
          <table className="table-css" >
            <thead className="table-heading">
              <tr className="custom-table-head-tr">
                <th className="table-heading-text text-left-sr">S. No.</th>
                <th className="table-heading-text text-center">Name</th>
                <th className="table-heading-text text-center">Overall Marks</th>
                {toggleCompany === 'null' && <th className="table-heading-text text-center">Sub Company</th>}
                <th className="table-heading-text text-center">Created At</th>
                <th className="table-heading-text text-center">Last Update</th>
                <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner-bgdatil"></div>
            ) : (
              <tbody>
                {appraisalType
                  ?.filter((e) =>
                    (e.name || "").toLowerCase().includes(searchQuery.toLowerCase())
                  )
                  .sort((a, b) =>
                    a.name?.localeCompare(b.name, "en", {
                      ignorePunctuation: true,
                    })
                  )
                  .sort((a, b) =>
                    a.sub_company_title?.localeCompare(b.sub_company_title, "en", {
                      ignorePunctuation: true,
                    })
                  )
                  .map((i, index) => (
                    <React.Fragment key={i.id}>
                      <tr className="custom-table-head-td ">
                        <td className="table-body">{index + 1}</td>
                        <td className="table-body text-center ">{i.name}</td>
                        <td className="table-body text-center ">{i.overall_marks}</td>
                        {toggleCompany === 'null' && <td className="table-body text-center">{i.sub_company_title}</td>}
                        <td className="table-body align-center">
                          {formatDateTime(i?.created_at).longdate}
                          <br />
                          <small>{formatDateTime(i?.created_at).time}</small>
                        </td>

                        <td className="table-body align-center">
                          <>
                            {i.updated_by &&
                              <>
                                <CustomImageModal customStyle>
                                  {i.updated_by_profilepic ? (
                                    <img
                                      src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                      alt="profile" className="profile-img"
                                    />
                                  ) : (
                                    <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                  )}
                                </CustomImageModal>
                                <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                              </>
                            }
                            {i.updated_by ?
                              <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                              :
                              <>
                                {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                                <br />
                                <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                              </>}
                          </>
                        </td>
                        <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                          <div className='flex-row justify-end'>
                            <UpdateAppraisalType
                              i={i}
                              getAppraisalTypes={getAppraisalTypes}
                              SUB_COMPANIES={SUB_COMPANIES}
                              SUPER_ADMIN={SUPER_ADMIN}
                            />
                            <DeleteAppraisalType
                              i={i}
                              getAppraisalTypes={getAppraisalTypes} />
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  )
}

// const AppraisalParameterHeadings = () => {
//   const [performanceHeadings, setAppraisalHeadings] = useState([]);
//   const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
//   const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
//   const [buffer, setBuffering] = useState(true); //buffering logic

//   const [searchQuery, setSearchQuery] = useState("");
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };
//   const getAppraisalHeadings = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-dynamic-parameterheading-by-subcompany/${toggleCompany}/`);
//       setAppraisalHeadings(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//       setBuffering(false); //buffering logic // End Buffering
//     }
//   };

//   useEffect(() => {
//     getAppraisalHeadings();
//   }, [toggleCompany]);

//   return (
//     <div className="table-css-white-background">
//       <div className="table-heading-flex">
//         <div className="repo-heading font-weight500 font-size-heading">Appraisal Parameter Headings</div>
//         <div className="field-cont">
//           {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
//             <Office />
//             <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
//               <option value="null">Select SubCompany</option>
//               {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

//             </select>
//           </div> : null
//           }
//           <div className="table-searchh">
//             <div>
//               <SearchSmall />
//               <input
//                 placeholder="Search"
//                 className="navbar-inputt font-weight400  font-size-text"
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//               />
//             </div>
//           </div>
//           <AppraisalParameterHeadingAdd appraisalHeadings={performanceHeadings} getAppraisalHeadings={getAppraisalHeadings} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
//         </div>
//       </div>
//       <table className="table-css">
//         <thead>
//           <tr className="custom-table-head-tr">
//             <th className="align-left">Sr. No.</th>
//             <th className="align-center">Position No.</th>
//             <th className="align-center">Name</th>
//             <th className="align-center">Type</th>
//             <th className="align-center">Company</th>
//             <th className="align-center">Created At</th>
//             <th className="align-center">Last Update</th>
//             <th className="align-right width-5vw">Action</th>
//           </tr>
//         </thead>
//         {buffer ? <div className="spinner"></div> : //buffering logic
//           <tbody>
//             {performanceHeadings?.filter((e) =>
//               e.title.toLowerCase().includes(searchQuery.toLowerCase())
//             )
//               .sort((a, b) => a.sorting_var - b.sorting_var)
//               .map((i, index) => (
//                 <React.Fragment key={index}>
//                   <tr className="tr-border-bottom">
//                     <td colSpan="6"></td>
//                   </tr>
//                   <tr className="custom-table-head-td">
//                     <td className="align-left">{index + 1}</td>
//                     <td className="align-center">{i.sorting_var}</td>
//                     <td className="align-center">{i.title}</td>
//                     <td className="align-center text-capitalize">{i.category_name}</td>
//                     <td className="align-center">{i.sub_company_title}</td>
//                     <td className="align-center">
//                       {formatDateTime(i?.created_at).longdate}
//                       <br />
//                       <small>{formatDateTime(i?.created_at).time}</small>
//                     </td>

//                     <td className="align-center">
//                       <>
//                         {i.updated_by &&
//                           <>
//                             <CustomImageModal customStyle>
//                               {i.updated_by_profilepic ? (
//                                 <img
//                                   src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
//                                   alt="profile" className="profile-img"
//                                 />
//                               ) : (
//                                 <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
//                               )}
//                             </CustomImageModal>
//                             <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
//                             {/* At- */}
//                           </>
//                         }
//                         {i.updated_by ?
//                           <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
//                           :
//                           <>
//                             {i?.updated_at && formatDateTime(i?.updated_at).longdate}
//                             <br />
//                             <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
//                           </>}
//                       </>
//                     </td>
//                     <td className="align-right width-5vw ">
//                       <div className="flex-row">
//                         <AppraisalParameterHeadingUpdate
//                           i={i}
//                           appraisalHeadings={performanceHeadings}
//                           getAppraisalHeadings={getAppraisalHeadings}
//                           SUB_COMPANIES={SUB_COMPANIES}
//                           SUPER_ADMIN={SUPER_ADMIN}
//                         />
//                         <AppraisalParameterHeadingDelete i={i} getAppraisalHeadings={getAppraisalHeadings} />
//                       </div>
//                     </td>
//                   </tr>
//                 </React.Fragment>
//               ))}
//           </tbody>
//         }
//       </table>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//     </div>
//   );
// };

// const AppraisalParameterHeadings = () => {
//   const [performanceHeadings, setAppraisalHeadings] = useState([]);
//   const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
//   const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
//   const [buffer, setBuffering] = useState(true); //buffering logic

//   const [searchQuery, setSearchQuery] = useState("");
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };
//   const getAppraisalHeadings = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/appraisal-dynamic-parameterheading-by-subcompany/${toggleCompany}/`);
//       setAppraisalHeadings(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//       setBuffering(false); //buffering logic // End Buffering
//     }
//   };

//   useEffect(() => {
//     getAppraisalHeadings();
//   }, [toggleCompany]);

//   return (
//     <div className="table-css-white-background">
//       <div className="table-heading-flex">
//         <div className="repo-heading font-weight500 font-size-heading">Appraisal Parameter Headings</div>
//         <div className="field-cont">
//           {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
//             <Office />
//             <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
//               <option value="null">Select SubCompany</option>
//               {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

//             </select>
//           </div> : null
//           }
//           <div className="table-searchh">
//             <div>
//               <SearchSmall />
//               <input
//                 placeholder="Search"
//                 className="navbar-inputt font-weight400  font-size-text"
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//               />
//             </div>
//           </div>
//           <AppraisalParameterHeadingAdd appraisalHeadings={performanceHeadings} getAppraisalHeadings={getAppraisalHeadings} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
//         </div>
//       </div>
//       <table className="table-css">
//         <thead>
//           <tr className="custom-table-head-tr">
//             <th className="align-left">Sr. No.</th>
//             <th className="align-center">Position No.</th>
//             <th className="align-center">Name</th>
//             <th className="align-center">Type</th>
//             <th className="align-center">Company</th>
//             <th className="align-center">Created At</th>
//             <th className="align-center">Last Update</th>
//             <th className="align-right width-5vw">Action</th>
//           </tr>
//         </thead>
//         {buffer ? <div className="spinner"></div> : //buffering logic
//           <tbody>
//             {performanceHeadings?.filter((e) =>
//               e.title.toLowerCase().includes(searchQuery.toLowerCase())
//             )
//               .sort((a, b) => a.sorting_var - b.sorting_var)
//               .map((i, index) => (
//                 <React.Fragment key={index}>
//                   <tr className="tr-border-bottom">
//                     <td colSpan="6"></td>
//                   </tr>
//                   <tr className="custom-table-head-td">
//                     <td className="align-left">{index + 1}</td>
//                     <td className="align-center">{i.sorting_var}</td>
//                     <td className="align-center">{i.title}</td>
//                     <td className="align-center text-capitalize">{i.category_name}</td>
//                     <td className="align-center">{i.sub_company_title}</td>
//                     <td className="align-center">
//                       {formatDateTime(i?.created_at).longdate}
//                       <br />
//                       <small>{formatDateTime(i?.created_at).time}</small>
//                     </td>

//                     <td className="align-center">
//                       <>
//                         {i.updated_by &&
//                           <>
//                             <CustomImageModal customStyle>
//                               {i.updated_by_profilepic ? (
//                                 <img
//                                   src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
//                                   alt="profile" className="profile-img"
//                                 />
//                               ) : (
//                                 <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
//                               )}
//                             </CustomImageModal>
//                             <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
//                             {/* At- */}
//                           </>
//                         }
//                         {i.updated_by ?
//                           <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
//                           :
//                           <>
//                             {i?.updated_at && formatDateTime(i?.updated_at).longdate}
//                             <br />
//                             <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
//                           </>}
//                       </>
//                     </td>
//                     <td className="align-right width-5vw ">
//                       <div className="flex-row">
//                         <AppraisalParameterHeadingUpdate
//                           i={i}
//                           appraisalHeadings={performanceHeadings}
//                           getAppraisalHeadings={getAppraisalHeadings}
//                           SUB_COMPANIES={SUB_COMPANIES}
//                           SUPER_ADMIN={SUPER_ADMIN}
//                         />
//                         <AppraisalParameterHeadingDelete i={i} getAppraisalHeadings={getAppraisalHeadings} />
//                       </div>
//                     </td>
//                   </tr>
//                 </React.Fragment>
//               ))}
//           </tbody>
//         }
//       </table>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//     </div>
//   );
// };

const AppraisalParameterHeadings = () => {
  const [performanceHeadings, setAppraisalHeadings] = useState([]);
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); // buffering logic

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getAppraisalHeadings = async () => {
    try {
      setBuffering(true);
      const url = toggleCompany && toggleCompany !== 'null'
        ? `${BASE_URL}/wfm/appraisal-sub-details-by-subcompany/${toggleCompany}/`
        : `${BASE_URL}/wfm/appraisal-sub-details/`;
      const res = await axios.get(url);
      setAppraisalHeadings(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getAppraisalHeadings();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500 font-size-heading">Appraisal Parameter Headings</div>
        <div className="field-cont">
          {SUPER_ADMIN ? (
            <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select
                onChange={(e) => setToggleCompany(e.target.value)}
                value={toggleCompany}
                className="dropdown font-size-subheading"
              >
                <option value="null">Select SubCompany</option>
                {SUB_COMPANIES?.map(company => (
                  <option key={company.id} value={company.id}>{company.title}</option>
                ))}
              </select>
            </div>
          ) : null}
          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400 font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <AppraisalParameterHeadingAdd
            appraisalHeadings={performanceHeadings}
            getAppraisalHeadings={getAppraisalHeadings}
            SUB_COMPANIES={SUB_COMPANIES}
            SUPER_ADMIN={SUPER_ADMIN}
          />
        </div>
      </div>

      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Position No.</th>
            <th className="align-center">Name</th>
            <th className="align-center">Type</th>
            <th className="align-center">Company</th>
            <th className="align-center">Created At</th>
            <th className="align-center">Last Update</th>
            <th className="align-right width-5vw">Action</th>
          </tr>
        </thead>

        {buffer ? (
          <tbody>
            <tr>
              <td colSpan="8">
                <div className="spinner"></div>
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {performanceHeadings?.filter((e) =>
              e.name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
              .sort((a, b) => a.sorting_order - b.sorting_order)
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="8"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>

                    <td className="align-center">{i.sorting_order}</td>

                    <td className="align-center">{i.name}</td>

                    <td className="align-center text-capitalize">{i.appraisal_type_name}</td>

                    <td className="align-center">{i.sub_company_title || '-'}</td>

                    <td className="align-center">
                      {formatDateTime(i?.created_at).longdate}
                      <br />
                      <small>{formatDateTime(i?.created_at).time}</small>
                    </td>

                    <td className="align-center">
                      <>
                        {i.updated_by && (
                          <>
                            <CustomImageModal customStyle>
                              {i.updated_by_profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }}
                                  customStyleforParent={"reqOutDuty-default-logo-dashboard"}
                                  customStyleforChild={'small-profile'}
                                />
                              )}
                            </CustomImageModal>
                            <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                          </>
                        )}
                        {i.updated_by ? (
                          <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                        ) : (
                          <>
                            {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                            <br />
                            <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                          </>
                        )}
                      </>
                    </td>

                    <td className="align-right width-5vw">
                      <div className="flex-row">
                        <AppraisalParameterHeadingUpdate
                          i={i}
                          appraisalHeadings={performanceHeadings}
                          getAppraisalHeadings={getAppraisalHeadings}
                          SUB_COMPANIES={SUB_COMPANIES}
                          SUPER_ADMIN={SUPER_ADMIN}
                        />
                        <AppraisalParameterHeadingDelete
                          i={i}
                          getAppraisalHeadings={getAppraisalHeadings}
                        />
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        )}
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const AppraisalRating = () => {
  const [rangeTypes, setRangeTypes] = useState([]);
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getRangeTypes = async () => {
    try {
      setBuffering(true);
      const url = toggleCompany && toggleCompany !== 'null'
        ? `${BASE_URL}/wfm/appraisal-rating-by-subcompany/${toggleCompany}/`
        : `${BASE_URL}/wfm/appraisal-rating/`;
      const res = await axios.get(url);
      setRangeTypes(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getRangeTypes();
  }, [toggleCompany]);

  // Helper to render the nested step configuration beautifully
  const renderSteps = (dataObj) => {
    if (!dataObj) return null;
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', justifyContent: 'center' }}>
        {Object.entries(dataObj)
          .filter(([key]) => key !== 'totalRating')
          .map(([key, val], idx) => (
            <span
              key={idx}
              style={{
                background: '#f1f3f5',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                border: '1px solid #dee2e6'
              }}
            >
              <strong>{key}</strong>: {val.min} - {val.max}
            </span>
          ))}
      </div>
    );
  };

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500 font-size-heading">Appraisal Range Types</div>
        <div className="field-cont">
          {SUPER_ADMIN ? (
            <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select
                onChange={(e) => setToggleCompany(e.target.value)}
                value={toggleCompany}
                className="dropdown font-size-subheading"
              >
                <option value="null">Select SubCompany</option>
                {SUB_COMPANIES?.map((company) => (
                  <option key={company.id} value={company.id}>{company.title}</option>
                ))}
              </select>
            </div>
          ) : null}
          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search by Label or Out Of..."
                className="navbar-inputt font-weight400 font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          {/* Add Range Component */}
          <AddRangeType
            getRangeTypes={getRangeTypes}
            SUB_COMPANIES={SUB_COMPANIES}
            SUPER_ADMIN={SUPER_ADMIN}
          />
        </div>
      </div>

      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Total Rating (Out Of)</th>
            <th className="align-center">Configuration Steps</th>
            <th className="align-center">Company</th>
            <th className="align-center">Created At</th>
            <th className="align-center">Last Update</th>
            <th className="align-right width-5vw">Action</th>
          </tr>
        </thead>

        {buffer ? (
          <tbody>
            <tr>
              <td colSpan="7">
                <div className="spinner"></div>
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {rangeTypes?.filter((e) => {
              const query = searchQuery.toLowerCase();
              // Check if out_of matches
              const matchesOutOf = e.out_of?.toString().toLowerCase().includes(query);
              // Check if any label inside 'data' matches
              const matchesLabels = e.data && Object.keys(e.data).some(key =>
                key !== 'totalRating' && key.toLowerCase().includes(query)
              );
              return matchesOutOf || matchesLabels;
            })
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="7"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>

                    <td className="align-center font-weight500">
                      Out of {i.out_of}
                    </td>

                    <td className="align-center">
                      {renderSteps(i.data)}
                    </td>

                    <td className="align-center">{i.sub_company_title}</td>

                    <td className="align-center">
                      {formatDateTime(i?.created_at).longdate}
                      <br />
                      <small>{formatDateTime(i?.created_at).time}</small>
                    </td>

                    <td className="align-center">
                      <>
                        {i.updated_by && (
                          <>
                            <CustomImageModal customStyle>
                              {i.updated_by_profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }}
                                  customStyleforParent={"reqOutDuty-default-logo-dashboard"}
                                  customStyleforChild={'small-profile'}
                                />
                              )}
                            </CustomImageModal>
                            <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                          </>
                        )}
                        {i.updated_by ? (
                          <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                        ) : (
                          <>
                            {i?.updated_at && formatDateTime(i?.updated_at).longdate}
                            <br />
                            <small>{i?.updated_at && formatDateTime(i?.updated_at).time}</small>
                          </>
                        )}
                      </>
                    </td>

                    <td className="align-right width-5vw">
                      <div className="flex-row">
                        <UpdateRangeType
                          i={i}
                          getRangeTypes={getRangeTypes}
                          SUB_COMPANIES={SUB_COMPANIES}
                          SUPER_ADMIN={SUPER_ADMIN}
                        />
                        <DeleteRangeType
                          i={i}
                          getRangeTypes={getRangeTypes}
                        />
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        )}
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};



export {
  // AppraisalFormsTableRH,
  AppraisalPendingApprovalsList,
  AppraisalFormsTableHOD,
  AppraisalFormsTableHODAdmin,

  AppraisalFormsTableRHHOD,
  AppraisalFormsTableRHHODAdmin,


  AppraisalParameterType,
  AppraisalParameterHeadings,

  AppraisalQuickFormSetup,
  AppraisalRating,
};
